import React, { useEffect, useState } from 'react';
import { CONSTANTS } from '../../constants';
import { AgGridReact } from 'ag-grid-react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import {
  TextButton,
  Dialog,
  TableContent,
  usePreventTableScrollingRef,
  CELL_RENDERERS,
  TextRenderer,
  TableContainer,
} from 'cdk-radial';
import '../../styles/ReviewTerms.scss';

export const ReviewTermsLocationNameDialog = () => {
  const { entityIdNameMapping, entityIdAddressMapping } = useSelector(
    (state) => state.loginDetailsSlice
  );

  const { requestedIntegrationStatuses } = useSelector(
    (state) => state.ManageIntegrationsV2Slice
  );
  const [isOpen, setIsOpen] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [totalRows, setTotalRows] = useState();

  const componentMainClass = 'selectedLocationsDialog__table';
  const agGridThemeClass = 'ag-theme-balham';
  const tableClass = classNames(componentMainClass, agGridThemeClass);

  const frameworkComponentsExtended = {
    textRenderer: TextRenderer,
  };

  const tableContentRef = usePreventTableScrollingRef();

  const columns = [
    {
      cellRenderer: CELL_RENDERERS.TEXT,
      field: 'location',
      width: 100,
      tooltipField: 'location'
    },
    {
      cellRenderer: CELL_RENDERERS.TEXT,
      field: 'address',
      width: 100,
      tooltipField: 'address'
    }
  ];
  const handleOpen = () => {
    setIsOpen(true);
  };

  const handlClose = () => {
    setIsOpen(false);
  };

  const handleGridReady = (gridParams) => {
    setGridApi(gridParams.api);
    setTotalRows(gridParams.api.getDisplayedRowCount());
    gridParams.api.sizeColumnsToFit();
  };

  useEffect(() => {
    let requestedLocations = [];
    for (const entityId of Object.keys(requestedIntegrationStatuses)) {
      if (requestedIntegrationStatuses[entityId] === 'enable') {
        requestedLocations.push({
          location: entityIdNameMapping[entityId],
          address: entityIdAddressMapping[entityId],
        });
      }
    }
    setRowData(requestedLocations);
  }, [requestedIntegrationStatuses]);

  return (
    <div className="review-terms-description">
      {CONSTANTS.REVIEW_TERMS_DESCRIPTION}
      <TextButton text={`${rowData.length} Location(s)`} onClick={handleOpen} />

      <Dialog
        isOpen={isOpen}
        onClose={handlClose}
        title={CONSTANTS.DEALERSHIP_LOCATIONS}
      >
        <div className='review-terms-locations'>
          <TableContainer
            className={tableClass}
            tableLayout={'normal'}
            hideBorder
          >
            <TableContent data-testid="table-content" ref={tableContentRef}>
              <AgGridReact
                defaultColDef={{
                  filter: false,
                  sortable: true,
                }}
                headerHeight={0}
                frameworkComponents={frameworkComponentsExtended}
                columnDefs={columns}
                rowHeight={60}
                onGridReady={handleGridReady}
                rowData={rowData}
                pagination={true}
                paginationPageSize={8}
              />
            </TableContent>
          </TableContainer>
        </div>
      </Dialog>
    </div>
  );
};
